module.exports = __webpack_public_path__ + "static/1-174e09759f80e4fce8d604eaa8bbd8ca.png";